<template>
  <b-modal :id="modalId"
           title="Change Password"
           @hide="clearData"
           size="lg">
    <errors-alert :errors="errors"></errors-alert>
    <form @submit.prevent="">
      <div class="container-fluid">
        <div v-if="enforceOldPassword" class="row form-group">
          <label class="col-4 col-form-label text-muted" for="old-passsword">Old Password:</label>
          <div class="col-6">
            <input class="form-control" :class="{'is-invalid': isOldPasswordInvalid}" type="password"
                   v-model.trim="oldPassword" id="old-passsword"/>
            <div v-show="isOldPasswordInvalid" class="invalid-feedback">
              Old password is not correct.
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-4 col-form-label text-muted" for="new-password">New Password:</label>
          <div class="col-6">
            <input class="form-control" :class="{'is-invalid': isNewPasswordInvalid || isNewPasswordEmpty}"
                   type="password"
                   v-model.trim="newPassword" id="new-password"/>
            <div v-show="isNewPasswordEmpty" class="invalid-feedback">
              Password cannot be empty.
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-4 col-form-label text-muted" for="confirm-new-password">Confirm New Password:</label>
          <div class="col-6">
            <input class="form-control" :class="{'is-invalid': isNewPasswordInvalid}" type="password"
                   v-model.trim="confirmNewPassword" id="confirm-new-password"/>
            <div v-show="isNewPasswordInvalid" class="invalid-feedback">
              Paswords don't match.
            </div>
          </div>
        </div>
      </div>
      <!-- dummy button for allowing press ENTER in the form -->
      <button hidden
              @click="promiseChangePassword = handleChangePassword()">
        Save Changes
      </button>
    </form>

    <template slot="modal-footer">
      <button class="btn btn-secondary" @click="hideModal">Close</button>
      <button class="mr-0 btn btn-success"
              @click="promiseChangePassword = handleChangePassword()"
              v-busy-button="promiseChangePassword">
        Save Changes
      </button>
    </template>
  </b-modal>
</template>

<script>
  import userService from '@/services/amio-api/user.service'
  import authService from '@/services/security/hosted-auth.service'
  import notificationService from '@/services/notification/notification.service'
  import userProfileService from '@/services/security/user-profile.service'
  import ErrorsAlert from '../common/ErrorsAlert.vue'

  export default {
    components: {
      'errors-alert': ErrorsAlert
    },

    props: {
      modalId: {
        type: String,
        required: true
      },
      user: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        promiseChangePassword: null,
        isOldPasswordInvalid: false,
        isNewPasswordInvalid: false,
        isNewPasswordEmpty: false,
        errors: []
      }
    },

    computed: {
      enforceOldPassword() {
        return this.user.email === userProfileService.getUserEmail()
      }
    },

    methods: {
      hideModal() {
        this.clearData()
        this.$root.$emit('bv::hide::modal', this.modalId)
      },

      clearData() {
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmNewPassword = ''
        this.isNewPasswordInvalid = false
        this.isOldPasswordInvalid = false
        this.isNewPasswordEmpty = false
        this.errors = []
        this.clearPromise()
      },

      clearPromise() {
        this.promiseChangePassword = null
      },

      validateOldPassword() {
        if (!this.enforceOldPassword || this.oldPassword) return true

        this.isOldPasswordInvalid = true
        return false
      },

      validateNewPassword() {
        if (this.newPassword) return true

        this.isNewPasswordEmpty = true
        return false
      },

      compareNewPasswords() {
        if (this.newPassword === this.confirmNewPassword) return true

        this.isNewPasswordInvalid = true
        return false
      },

      handleChangePassword() {
        if (!this.validateOldPassword()) return

        this.isOldPasswordInvalid = false
        if (!this.validateNewPassword()) return

        this.isNewPasswordEmpty = false
        if (!this.compareNewPasswords()) return

        this.isNewPasswordInvalid = null
        const updateData = {
          password: this.newPassword,
          connectionName: authService._getAuth0Props().connectionName
        }
        if (this.enforceOldPassword) updateData.oldPassword = this.oldPassword
        return userService.update(this.user.id, updateData, [422])
          .then(() => {
            notificationService.success('Password was successfully changed')
          })
          .then(this.hideModal)
          .catch(error => {
            if (error.response.status !== 422) return

            log.debug('wrong password entered', error)
            this.errors = error.response.data.errors
            this.clearPromise()
          })
      }
    }
  }
</script>
